import axios from "axios";
import { BASE_URL } from "@config/variables";
import { configs } from "@config/config";
import { getNodeServerUrl } from "@utils/getNodeUrl";

/**
 * My User Service
 * Centralized service for all My User related API calls
 * No centralized endpoints dependency - all endpoints inlined
 */

/**
 * Get picklist values for Category and Sub-Category
 * @returns {Promise<Object>} Picklist values or error
 */
export const getPicklistValues = async () => {
  const options = {
    url: `${BASE_URL}/services/data/v56.0/ui-api/object-info/Capture_Insight__c/picklist-values/${configs.my_user_api_id}`,
    method: "get",
  };
  
  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Something Went Wrong..!!",
    };
  }
};

/**
 * Get user name by mobile number
 * @param {string} mobileNo - 10 digit mobile number
 * @returns {Promise<Object>} User data or error
 */
export const getUserByMobile = async (mobileNo) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/myuser/get-user-name`,
    method: "post",
    headers: headers,
    data: { mobileNo },
  };
  
  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};

/**
 * Add user visit feedback
 * @param {Object} payload - Complete user feedback payload
 * @returns {Promise<Object>} Response with success status and data
 */
export const addUserFeedback = async (payload) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/MyUser/`,
    method: "post",
    data: payload,
  };
  
  try {
    const response = await axios(options);
    if (response?.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Failed to submit feedback");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Failed to submit feedback",
    };
  }
};
